import React, { useEffect } from "react";
import { useReactiveVar } from "@apollo/client";

import { userDeatils } from "../../ReactiveVariables/index";
import LoginHeader from "Modules/Login/LoginHeader";
import Footer from "Modules/Common/footer";
import { NextJsLanding } from "./components/next-js-landing";

export function Home() {
  const user = useReactiveVar(userDeatils);
  const currentUserPromoField = user?.data?.currentUserDetails?.disableSignUpPromo;
  const loginPromoField = user?.data?.login?.disableSignUpPromo;
  const disableSignUpPromo = !currentUserPromoField ? loginPromoField : currentUserPromoField;

  useEffect(() => {
    if (!disableSignUpPromo) {
      // Handle promo popup logic here if needed
    }
  }, [disableSignUpPromo]);

  return (
    <div>
      <LoginHeader />
      <div className="pageWrap">
        <NextJsLanding />
        <Footer />
      </div>
    </div>
  );
}
